import "./Spinner.css"

export const Spinner = ({className = ""}) => {
    return(
        <div className={`spinner text-purple-700 text-xl ${className}`}>
            <i className="fa-solid fa-circle-notch"></i>
        </div>
    )
}
